<div class="content">
  <div class="loader" *ngIf="isLoadingAssignments">
    <app-three-dots-blinking></app-three-dots-blinking>
  </div>
  <div *ngIf="!isLoadingAssignments">
    <div class="top-bar">
      <div>
        <div class="team" *ngIf="teams.length > 0">
          <small>{{'teams.MY_TEAMS' | transloco}}</small><br />
          <span class="team-name" *ngIf="teams.length === 1">{{
            selectedTeam.name
          }}</span>
          <ng-container *ngIf="teams.length > 1">
            <mat-select
              [value]="selectedTeam.name"
              id="teamSelect"
              hasBackdrop="true"
              (selectionChange)="onSelectTeamsChange($event)"
            >
              <mat-option
                *ngFor="let teamItem of teams"
                [value]="teamItem.name"
              >
                {{ teamItem.name }}
              </mat-option>
            </mat-select>
          </ng-container>
        </div>

        <div class="team right" *ngIf="assignments.length > 0">
          <small>{{'teams.ASSIGNMET_MODULE' | transloco}}</small><br />
          <span class="team-name" *ngIf="assignments.length === 1">{{
            selectedModuleAssignment?.name
          }}</span>
          <ng-container *ngIf="assignments.length > 1">
            <mat-select
              [value]="selectedModuleAssignment?.name"
              id="assignmentSelect"
              hasBackdrop="true"
              (selectionChange)="onSelectModuleChange($event)"
            >
              <mat-option
                *ngFor="let assignmentItem of assignments"
                [value]="assignmentItem.name"
              >
                <span>{{ assignmentItem.name }} </span>
                <small *ngIf="assignmentItem.dueDate"
                  >Due:
                  {{ assignmentItem.dueDate | localeDate : "date" }}</small
                >
              </mat-option>
            </mat-select>
          </ng-container>
        </div>
      </div>
    </div>

    <div *ngIf="assignments.length > 0">
      <div class="assignment">
        <div class="container">
          <div class="inner-container">
            <div class="assignment-info">
              <div>
                <small>{{'teams.START_DATE' | transloco}}</small><br />
                <span>{{
                  moduleAssignmentSummary.startDate | localeDate : "date"
                }}</span>
              </div>
              <br />
              <div *ngIf="moduleAssignmentSummary.dueDate">
                <small>{{'teams.DUE_DATE' | transloco}}</small><br />
                <span>{{
                  moduleAssignmentSummary.dueDate | localeDate : "date"
                }}</span>
              </div>
              <br />
              <div>
                <small>{{'teams.ASSIGNED_MEMBERS' | transloco}}</small><br />
                <span>{{ moduleAssignmentSummary.assignedMembers | localeNumber:0 }}</span>
              </div>
              <br />
              <div>
                <small>{{'teams.CALLS_IN_MODULE' | transloco}}</small><br />
                <span>{{ moduleAssignmentSummary.callsInModuleAssignment | localeNumber:0 }}</span>
              </div>
              <br />
              <div>
                <small>{{'teams.COMPLETION_REQUIRMENT' | transloco}}</small><br />
                <span
                  >{{'teams.COMPLETE_ALL_CALLS' | transloco}}
                  {{ moduleAssignmentSummary.completionRequirement | localeNumber:1:true }} {{'teams.OR_HIGHER' | transloco}}</span
                >
              </div>
            </div>
            <div class="assignment-container">
              <div>
                <span>{{'teams.PROGRESS_OVERVIEW' | transloco}}</span>
                <div>
                  <div>
                    <div>
                      <div class="progress-bar-container">
                        <div
                          class="progress-bar"
                          [ngStyle]="{ 'width.%': completedModule.percentage }"
                        ></div>
                      </div>
                      <div class="progress-container">
                        <div class="completed">
                          <div>
                            <small>{{'teams.COMPLETED' | transloco}}</small>
                          </div>
                          <div>
                            <span>{{ completedModule.percentage }}</span>
                            <span>%</span>
                          </div>
                          <div class="team-members">
                            <label
                              >{{ completedModule.membersQuantity }} {{'teams.TEAM_MEMBERS' | transloco}}</label
                            >
                          </div>
                        </div>
                        <div class="separator"></div>
                        <div class="border-element"></div>
                        <div class="separator"></div>
                        <div class="in-progress">
                          <div>
                            <div>
                              <small>{{'teams.IN_PROGRESS' | transloco}}</small>
                            </div>
                            <div>
                              <span>{{ inProgressModule.percentage }}</span>
                              <span>%</span>
                            </div>
                            <div class="team-members">
                              <label
                                >{{ inProgressModule.membersQuantity }} {{'teams.TEAM_MEMBERS' | transloco}}</label
                              >
                            </div>
                          </div>
                        </div>
                        <div class="separator"></div>
                        <div class="not-started">
                          <div>
                            <div>
                              <small>{{'teams.NOT_STARTED' | transloco}}</small>
                            </div>
                            <div>
                              <span>{{ notStartedModule.percentage }}</span>
                              <span>%</span>
                            </div>
                            <div class="team-members">
                              <label
                                >{{ notStartedModule.membersQuantity }} {{'teams.TEAM_MEMBERS' | transloco}}</label
                              >
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div>
                    <div>
                      <small>{{'teams.AVERAGE_HIGH_SCORE' | transloco}}</small><br />
                      <span>{{ moduleAssignmentSummary.averageScore | localeNumber:1:true }}</span>
                      <small>/5</small>
                    </div>
                    <br /><br />
                    <div>
                      <small>{{'teams.AVERAGE_NUMBER_ATTEMPTS_CALL' | transloco}}</small><br />
                      <span>{{ moduleAssignmentSummary.averageAttemptsPerCall | localeNumber:1 }}</span>
                    </div>
                    <br /><br />
                    <div>
                      <small>{{'teams.TOTAL_PRACTICES' | transloco}}</small><br />
                      <span>{{ moduleAssignmentSummary.totalPractices | localeNumber:0 }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Commented for now, can be resumed in future reference(SR-14 a comment by Colin at 22-02-2024  ) -->
      <!-- <div class="chart">
        <div class="chart-container">
          <div class="practice-label">
            <label>PRACTICE RATE</label>
          </div>
          <div>
            <div>
              <span>Total practices </span>
            </div>
            <div>
              <canvas id="lineChart" height="100px"></canvas>
            </div>
          </div>
          <div>
            <div>
              <small>Total:</small>
              <small>{{
                teamCallCount.practiceRateSummary.practiceCount
              }}</small>
            </div>
            <div>
              <small>Average per day:</small>
              <small>{{
                teamCallCount.practiceRateSummary.averagePerDay
              }}</small>
            </div>
          </div>
        </div>
      </div> -->

      <div class="call-progress">
        <div class="chart-container">
          <div class="practice-label">
            <label>{{'teams.INDIVIDUAL_CALL_PROGRESS' | transloco}}</label>
          </div>
          <div
            class="call-container"
            *ngFor="let call of summaryCalls; let i = index"
          >
            <div class="container">
              <div>
                <span>{{ call.name }}</span>
              </div>
              <div>
                <div>
                  <div>
                    <label>% {{'teams.OF_TEAM_MEMBERS' | transloco}}</label>
                  </div>
                  <div>
                    <div class="progress-bar-container">
                      <div
                        class="progress-bar"
                        [ngStyle]="{ 'width.%': call.percentageComplete }"
                      ></div>
                    </div>
                    <span>{{ call.percentageComplete }}%</span>
                  </div>
                </div>
                <div>
                  <small>{{'teams.TOTAL_PRACTICES' | transloco}}</small><br />
                  <span>{{ call.totalPractices | localeNumber:0 }}</span>
                </div>
                <div>
                  <small>{{'teams.AVERAGE_PRACTICES_TO_COMPLETION' | transloco}}</small><br />
                  <span>{{ call.averagePracticesToCompletion | localeNumber:1 }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <section id="data">
        <div>
          <div>
            <div>
              <div class="team-member-label">
                <label>{{'teams.TEAM_MEMBER_DETAILS' | transloco}}</label>
              </div>
              <div>
                <label class="download-csv" (click)="getTeamMembersActivity()"
                  >{{'teams.DOWNLOAD_ACTIVITY_REPORT' | transloco}}</label
                >
              </div>
            </div>
            <table>
              <thead>
                <tr>
                  <th (click)="changeSort('firstName')">
                    <div>
                      {{'teams.TEAM_MEMBER' | transloco}}
                      <span [ngClass]="sortNameClass"></span>
                    </div>
                  </th>
                  <th (click)="changeSort('progressStatus')">
                    <div>
                      {{'teams.PROGRESS' | transloco}}
                      <span [ngClass]="sortAssignementProgressClass"></span>
                    </div>
                  </th>
                  <th (click)="changeSort('callsCompleted')">
                    <div>
                      {{'teams.CALLS_COMPLETED' | transloco}}
                      <span [ngClass]="sortCallsCompletedClass"></span>
                    </div>
                  </th>
                  <th (click)="changeSort('totalPractices')">
                    <div>
                      {{'teams.PRACTICES' | transloco}}
                      <span [ngClass]="sortPracticesClass"></span>
                    </div>
                  </th>
                  <th (click)="changeSort('recentActivityDate')">
                    <div>
                      {{'teams.MOST_RECENT_PRACTICE' | transloco}}
                      <span [ngClass]="sortMostRecentActivityClass"></span>
                    </div>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let teamMember of teamMembers; let i = index">
                  <td>
                    <div class="name">
                      <div class="initials">
                        {{ teamMember.firstName[0] + teamMember.lastName[0] }}
                      </div>
                      {{ teamMember.firstName + " " + teamMember.lastName }}
                    </div>
                  </td>
                  <td>
                    <div
                      class="assignement_progress not-started"
                      *ngIf="
                        teamMember.progressStatus === 'NOTSTARTED' ||
                        teamMember.progressStatus === 'ACCOUNTNOTACTIVATED'
                      "
                    >
                      <img src="assets/icons/alert-circle-outline.svg" />
                      {{'teams.NOT_STARTED' | transloco}}
                    </div>
                    <div
                      class="assignement_progress in-progress"
                      *ngIf="teamMember.progressStatus === 'INPROGRESS'"
                    >
                      <img src="assets/icons/running-man-icon.svg" />
                      {{'teams.IN_PROGRESS' | transloco}}
                    </div>
                    <div
                      class="assignement_progress completed"
                      *ngIf="teamMember.progressStatus === 'COMPLETED'"
                    >
                      <img src="assets/icons/certified.svg" />
                      {{'teams.COMPLETED' | transloco}}
                    </div>
                  </td>
                  <td>
                    <span (click)="openModal($event, i)" [id]="'modalButton'">
                      {{ teamMember.callsCompleted }}
                    </span>
                  </td>
                  <td>{{ teamMember.totalPractices }}</td>
                  <td>
                    <div class="activity">
                      <div *ngIf="teamMember.recentActivity === ''">-</div>
                      <div
                        *ngIf="
                          teamMember.recentActivity !== '' &&
                          teamMember.totalPractices < 1
                        "
                      >
                        -
                      </div>
                      <div
                        *ngIf="
                          teamMember.recentActivity !== '' &&
                          teamMember.totalPractices > 0
                        "
                      >
                        {{ teamMember.recentActivity | localeDate : "date" }}
                      </div>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </section>
    </div>

    <section id="no-assignments" *ngIf="assignments.length === 0">
      <div class="no-assignments">
        <img src="assets/icons/empty-icon.svg" />
        <p>{{'teams.THIS_TEAM_HAS_NO_ACTIVE_ASSIGNMENTS' | transloco}}</p>
      </div>
    </section>
  </div>
</div>
